export default __webpack_public_path__ + "static/media/logo-white.9dea1762.svg";